import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const ModalDebitorSearch = ({ setDebitor }) => {
  const { t } = useTranslation()

  const [InputData, setInputData] = useState({
    customer_number: '',
    zipcode: '',
    city: '',
    customer_name: '',
  })

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)

  const [Fdata, setFdata] = useState(false)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  const FormSubmit = (e) => {
    e.preventDefault()

    const data = new FormData()
    data.append('debitor_search[customer_number]', InputData.customer_number)
    data.append('debitor_search[zipcode]', InputData.zipcode)
    data.append('debitor_search[city]', InputData.city)
    data.append('debitor_search[customer_name]', InputData.customer_name)

    setFdata(data)
    setPartnerPortalUrl(apiURL('debitor_search'))

    return true
  }

  const [SelectedDebitor, setSelectedDebitor] = useState(false)
  const FormSubmitDebitor = (e) => {
    e.preventDefault()
    setDebitor(SelectedDebitor)
    return true
  }

  useEffect(() => {
    if (data && data[0].customer) {
      setSelectedDebitor(parseInt(data[0].customer))
    }
  }, [data])

  return (
    <>
      <form onSubmit={(e) => FormSubmit(e)}>
        <div className="row mb-1">
          <div className="col-md-3">
            <label htmlFor="customer_number">
              {t('generic.spa.customer_number')}
            </label>
          </div>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control"
              name="customer_number"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  customer_number: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-md-3">
            <label htmlFor="zipcode">{t('generic.spa.zipcode')}</label>
          </div>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control"
              name="zipcode"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  zipcode: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-md-3">
            <label htmlFor="city">{t('generic.spa.city')}</label>
          </div>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control"
              name="city"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  city: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-md-3">
            <label htmlFor="customer_name">
              {t('generic.spa.customer_name')}
            </label>
          </div>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control"
              name="customer_name"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  customer_name: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="mb-1 pull-right">
          <button className="btn btn-primary btn-sm" type="submit">
            {t('generic.spa.send')}
          </button>
        </div>
      </form>

      {loading && <LoadingSpinner />}

      {data && (
        <div className="mt-1">
          <div className="row mb-1">
            <div className="col-md-3">{t('generic.spa.debitor')}</div>
            <div className="col-md-9">
              <select
                name="customer_number"
                onChange={(e) => setSelectedDebitor(e.target.value)}
              >
                {data.map((c, index) => (
                  <option key={index} value={parseInt(c.customer)}>
                    {c.customer} | {c.name} | {c.postl_cod1} | {c.city}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mb-1 pull-right">
            <button
              className="btn btn-primary btn-sm"
              onClick={(e) => FormSubmitDebitor(e)}
            >
              {t('generic.spa.select_debitor')}
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default ModalDebitorSearch
